export default __webpack_public_path__ + "static/flop-products-03ab860348e22e3985142dbed65e700d.png";